import React from 'react';

const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "medium",
  fullScreen = false,
  className = ""
}) => {
  const sizeClasses = {
    small: "w-4 h-4",
    medium: "w-8 h-8", 
    large: "w-12 h-12"
  };

  const containerClasses = fullScreen 
    ? "doglingo-loading--fullscreen" 
    : "doglingo-loading";

  return (
    <div className={`${containerClasses} ${className}`}>
      <div className="doglingo-loading__container">
        <div className={`doglingo-loading__spinner ${sizeClasses[size]}`}></div>
        {message && (
          <div className="doglingo-loading__text">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner; 